"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgPieChart = function SvgPieChart(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M21.917 14.43a1 1 0 01-.517 1.317A9 9 0 1033.289 27.5a1 1 0 011.842.778A11 11 0 1120.6 13.913a1 1 0 011.317.517zM25 13a11 11 0 0111 11 1 1 0 01-1 1H25a1 1 0 01-1-1V14a1 1 0 011-1zm1 2.056V23h7.944A9 9 0 0026 15.056z",
    id: "pie-chart_svg__a"
  }));
};

var _default = SvgPieChart;
exports["default"] = _default;